import { useState } from 'react'
import { useContext } from 'react';
import ServicesContext from '../contexts/servicesContext';
import useFetchData from './useFetchData';

function useDictionaries({
    fetchSocialStatusTypes = false,
    fetchCountries = false,
    fetchRegions = false,
    fetchEducationInstitutionTypes = false,
    fetchLanguages = false,
    fetchLocalities = false,
    fetchLocalityTypes = false,
    fetchDistinctionMarkTypes = false,
    fetchAcademicDegrees = false,
    fetchExamTypes = false,
    fetchQuota = false,
    fetchEnglishCertificateTypes = false,
    fetchOlympiadCertificateTypes = false,
    fetchAdditionalCourses = false,
    fetchFinancingPrograms = false,
    fetchInstitutions = false,
    fetchDocuments = false,
}) {
    const services = useContext(ServicesContext);

    const { data: socialStatusTypes } = useFetchData(services.secretary.getSocialStatusTypes, fetchSocialStatusTypes);
    const { data: countries } = useFetchData(services.educationInfo.getCountries, fetchCountries);
    const { data: regions } = useFetchData(services.educationInfo.getAllKatoRegions, fetchRegions);
    const { data: educationInstitutionTypes } = useFetchData(services.educationInfo.getEducationInstitutionTypes, fetchEducationInstitutionTypes);
    const { data: examLanguages } = useFetchData(services.educationInfo.getExamLanguages, fetchLanguages);
    const { data: localities } = useFetchData(services.educationInfo.getLocalities, fetchLocalities);
    const { data: localityTypes } = useFetchData(services.educationInfo.getLocalityTypes, fetchLocalityTypes);
    const { data: distinctionMarkTypes } = useFetchData(services.educationInfo.getDistinctionMarkTypes, fetchDistinctionMarkTypes);
    const { data: academicDegrees } = useFetchData(services.admissionInfo.getAcademicDegrees, fetchAcademicDegrees);
    const { data: examTypes } = useFetchData(services.admissionInfo.getExamTypes, fetchExamTypes);
    const { data: quotas } = useFetchData(services.admissionInfo.getQuota, fetchQuota);
    const { data: englishCertificateTypes } = useFetchData(services.admissionInfo.getEnglishCertificateTypes, fetchEnglishCertificateTypes);
    const { data: olympiadCertificateTypes } = useFetchData(services.admissionInfo.getOlympiadCertificateTypes, fetchOlympiadCertificateTypes);
    const { data: additionalCourses } = useFetchData(services.admissionInfo.getAdditionalCourses, fetchAdditionalCourses);
    const { data: financingPrograms } = useFetchData(services.admissionInfo.getFinancingPrograms, fetchFinancingPrograms);
    const { data: documents } = useFetchData(services.dictionary.getDocumentTypes, fetchDocuments);
    const { data: institutions } = useFetchData(services.dictionary.getIssuingAuthority, fetchInstitutions);

    const [residencePlaces, setResidencePlaces] = useState([]);
    const [lifePlaces, setLifePlaces] = useState([]);
    const [educationalDUPrograms, setEducationalDUPrograms] = useState([]);

    const handleKatoPlacesByRegion = (id, type) => {
        if (type === "residence") {
            services.educationInfo
                .getAllKatoPlacesByRegion(id)
                .then((response) => {
                    setResidencePlaces(response.data)
                });
        }
        if (type === "life") {
            services.educationInfo
                .getAllKatoPlacesByRegion(id)
                .then((response) => {
                    setLifePlaces(response.data)
                });
        }
    };

    const handleDUEducationalPrograms = (selectedAcademicDegree) => {
        services.admissionInfo
            .getDUEducationalPrograms(selectedAcademicDegree)
            .then((response) => {
                setEducationalDUPrograms(response.data);
            });
    }

    const languages = [
        {
            "id": 1,
            "name": "Казахский",
            "code": "kz"
        },
        {
            "id": 2,
            "name": "Русский",
            "code": "ru"
        },
        {
            "id": 3,
            "name": "Английский",
            "code": "en"
        }
    ];


    const assessments = [
        {
            value: 2,
        },
        {
            value: 3,
        },
        {
            value: 4,
        },
        {
            value: 5,
        },
    ];

    // 728,турки
    // 755,узбеки
    // 756,уйгуры
    // 759,украинцы
    // 852,чеченцы
    // 857,чуваши
    const nationalities = [
        {
            value: "271",
            label: "казах",
        },
        {
            value: "324",
            label: "киргиз",
        },
        {
            value: "341",
            label: "кореец",
        },
        {
            value: "367",
            label: "курд",
        },
        {
            value: "468",
            label: "молдаванин",
        },
        {
            value: "476",
            label: "мордовец",
        },
        {
            value: "571",
            label: "поляк",
        },
        {
            value: "591",
            label: "русские",
        },
        {
            value: "647",
            label: "таджик",
        },
        {
            value: "658",
            label: "татарин",
        },
        {
            value: "728",
            label: "турок",
        },
        {
            value: "755",
            label: "узбек",
        },
        {
            value: "756",
            label: "уйгур",
        },
        {
            value: "759",
            label: "украинец",
        },
        {
            value: "852",
            label: "чеченец",
        },
        {
            value: "857",
            label: "чуваш",
        },
        {
            value: "23",
            label: "азербайджанец",
        },
        {
            value: "97",
            label: "башкир",
        },
        {
            value: "104",
            label: "белорус",
        },
        {
            value: "165",
            label: "грек",
        },
        {
            value: "203",
            label: "дунганин",
        },
        {
            value: "209",
            label: "еврей",
        },
        {
            value: "247",
            label: "ингуш",
        },
        {
            value: "57",
            label: "армянин",
        },
        {
            value: "499",
            label: "немец",
        },
        {
            value: "925",
            label: "пакистанец",
        },
        {
            value: "1000",
            label: "другое",
        },
    ];

    return {
        dictionary: {
            socialStatusTypes,
            countries,
            regions,
            residencePlaces,
            lifePlaces,
            educationInstitutionTypes,
            examLanguages,
            languages,
            localities,
            localityTypes,
            distinctionMarkTypes,
            nationalities,
            academicDegrees,
            examTypes,
            quotas,
            englishCertificateTypes,
            olympiadCertificateTypes,
            additionalCourses,
            financingPrograms,
            educationalDUPrograms,
            assessments,
            documents,
            institutions,
        },
        handlers: {
            handleDUEducationalPrograms,
            handleKatoPlacesByRegion,
        }
    };
}

export default useDictionaries;
